/**
 * Volta do Google depois de "Conectar Google Agenda" (ADR-0093).
 *
 * O Google traz a pessoa para cá com o código e o estado; a tela (com a
 * sessão de quem está logado) entrega os dois ao backend, que confere se o
 * estado é desta pessoa, cria o calendário "Pharu ERP" e começa a sincronizar.
 * Em seguida volta para Configurações › Calendário no celular.
 */
import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { useAuth } from "../../context/AuthContext";
import { useToast } from "../../context/ToastContext";
import { concluirGoogle } from "../../services/agenda";
import "./tabs/IntegracoesIA.css";

export const DESTINO = "/configuracoes/calendario-celular";

export default function RetornoGoogle() {
  const { request } = useAuth();
  const toast = useToast();
  const navigate = useNavigate();
  const { search } = useLocation();
  const [erro, setErro] = useState("");
  const enviado = useRef(false);

  useEffect(() => {
    // O código do Google vale uma vez: o StrictMode roda o efeito duas vezes.
    if (enviado.current) return;
    enviado.current = true;
    const parametros = new URLSearchParams(search);
    if (parametros.get("error")) {
      setErro("A conexão foi cancelada na tela do Google. Nada foi alterado.");
      return;
    }
    concluirGoogle(request, parametros.get("code") || "", parametros.get("state") || "")
      .then(() => {
        toast.success("Google Agenda conectado. A primeira sincronização começa em instantes.");
        navigate(DESTINO, { replace: true });
      })
      .catch((e) => setErro(e?.message || "Não deu para conectar o Google Agenda."));
  }, [search, request, toast, navigate]);

  return (
    <div className="cal-retorno" aria-live="polite">
      {erro ? (
        <>
          <b>Google Agenda não conectado</b>
          <p className="ia-erro">{erro}</p>
          <Link className="btn btn--ghost btn--sm" to={DESTINO}>Voltar para Calendário no celular</Link>
        </>
      ) : (
        <>
          <b>Conectando ao Google Agenda…</b>
          <p>Criando o calendário “Pharu ERP” na sua conta.</p>
        </>
      )}
    </div>
  );
}
